import { useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setAnalyticsUserId, setAnalyticsUserProperties, useAnalyticsConsent } from '../utils/analytics';
import useEngagementTracking from '../hooks/useEngagementTracking';
import AuthContext from '../context/AuthContext';

const PageTracker = () => {
    const location = useLocation();
    const { user } = useContext(AuthContext);
    const consent = useAnalyticsConsent();

    useEffect(() => {
        if (user && consent) {
            if (user._id || user.id) {
                setAnalyticsUserId(user._id || user.id);
            }
            setAnalyticsUserProperties({
                user_role: user.role || 'user',
                is_logged_in: true
            });
        }
    }, [user, consent]);

    useEffect(() => {
        if (consent) {
            trackPageView(location.pathname + location.search);
        }
    }, [location, consent]);

    // Automatically track scroll depth, time on page, and exit intent
    useEngagementTracking();

    return null;
};

export default PageTracker;
